// extracted by mini-css-extract-plugin
export default {"quote":"about_quote__bm+wr","home-img":"about_home-img__UBneH"};